/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NavigationItem = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        icon: {
    type: 'string',
    isRequired: true,
},
        label: {
    type: 'string',
    isRequired: true,
},
        secondaryLabel: {
    type: 'string',
},
        rootPath: {
    type: 'string',
    isRequired: true,
},
        fetchPrimaryNotice: {
    type: 'string',
},
        fetchSecondaryNotice: {
    type: 'string',
},
        noticeColor: {
    type: 'string',
},
        noticeColorSecondary: {
    type: 'string',
},
        enabled: {
    type: 'boolean',
    isRequired: true,
},
    },
};